<template>
  <div class="FieldBtns">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.FieldBtns {
  bottom: 0.55rem;
  margin-left: $grid-unit-half;
  position: absolute;
  right: 0.5rem;
  z-index: 1;

  > .FieldBtn {
    position: static;
  }
}
</style>
